<app-card icon="map" title="Route Performance" subtitle="Detailed comparison with last year" iconGradient="from-orange-500 to-red-500" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'best-seller-route'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="bestSellerRouteData() || []"
        [loading]="loading()"
    ></app-table-component>
    <!-- Templates -->
    <ng-template #routeTemplate let-rowData="rowData">
        <span class="route-code">{{ rowData.route.depPort }}</span>
        <span class="route-arrow">→</span>
        <span class="route-code">{{ rowData.route.arrPort }}</span>
    </ng-template>

    <ng-template #growthTemplate let-rowData="rowData">
        @if (rowData.reservation >= rowData.lastYearReservation) {
            <span class="growth">▲ {{ rowData.reservation - rowData.lastYearReservation }}</span>
        } @else {
            <span class="growth" style="color: #de3d5b;">▼ {{ rowData.lastYearReservation - rowData.reservation }}</span>
        }
    </ng-template>

    <ng-template #revenueTemplate let-rowData="rowData">
        <span class="money">{{ rowData.revenue | number: '1.2-2' }}</span>
    </ng-template>
</app-card>
